/**
 * @generated SignedSource<<52bddb515890897026ae60eb6c9fa83c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type maintenance_viewer$data = {
  readonly component: string | null;
  readonly downForMaintenance: boolean | null;
  readonly " $fragmentType": "maintenance_viewer";
};
export type maintenance_viewer$key = {
  readonly " $data"?: maintenance_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"maintenance_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "maintenance_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "maintenance"
        }
      ],
      "kind": "ScalarField",
      "name": "component",
      "storageKey": "component(name:\"maintenance\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downForMaintenance",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e1930cc4ebc9273d3744932aa182fff4";

export default node;
